import { App } from '../work-modules/025/App';
import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('webgl-canvas') as HTMLCanvasElement;
  const app = new App(canvas);
  app.initialize();
});